import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logo from "../assets/favicomatic/apple-touch-icon-120x120.png";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white text-black flex flex-col items-center justify-center px-6 py-12">
      <div className="text-center space-y-6">
        <img
          src={logo}
          alt="404"
          className="w-30 h-30 mx-auto animate-bounce"
        />

        <h1 className="text-5xl font-extrabold tracking-tight ">
          404 – Página no encontrada
        </h1>

        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Ups... parece que te perdiste en el tiempo. Pero no te preocupes,
          puedes volver al dashboard y retomar el control de tus proyectos.
        </p>

        <Button asChild className="mt-4 bg-purple-600 hover:bg-purple-700">
          <Link to="/dashboard">Volver al Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
